import { createElementBlock as e, openBlock as o, normalizeClass as s, createCommentVNode as r, createStaticVNode as i, createElementVNode as d, toDisplayString as n } from "vue";
import { themeProp as V } from "../../composables/useTheme.js";
/* empty css          */
import p from "../../_virtual/_plugin-vue_export-helper.js";
const m = ["aria-label"], H = {
  key: 0,
  class: "ds-logo__label ds-text-mono",
  "data-j-logo-label": ""
}, g = { class: "ds-logo__text" }, b = "DsLogo", c = /* @__PURE__ */ Object.assign({
  name: b
}, {
  __name: "logo",
  props: {
    ...V,
    ariaLabel: { type: String, required: !0 },
    label: { type: String, default: null }
  },
  setup(t) {
    return (l, a) => (o(), e("div", {
      class: s(`ds-logo ds-logo--${l.theme}`),
      "data-j-logo": ""
    }, [
      (o(), e("svg", {
        "aria-label": t.ariaLabel,
        role: "img",
        class: "ds-logo__image",
        xmlns: "http://www.w3.org/2000/svg",
        width: "92",
        height: "30",
        viewBox: "0 0 92 30",
        fill: "none",
        "data-j-logo-image": ""
      }, a[0] || (a[0] = [
        i('<path d="M0.666626 7H14C15.4733 7 16.6666 8.19333 16.6666 9.66667V23H3.33329C1.85996 23 0.666626 21.8067 0.666626 20.3333V13.6667H7.33329V19H9.99996V11H0.666626V7Z" data-v-bddf862b></path><path d="M75.3333 7V23H82V11H84.6666V23H91.3333V9.66667C91.3333 8.19333 90.14 7 88.6666 7H75.3333Z" data-v-bddf862b></path><path d="M38 29.6667H51.3333C52.8067 29.6667 54 28.4733 54 27V7H47.3333V19H44.6667V7H38V20.3333C38 21.8067 39.1933 23 40.6667 23H47.3333V25.6667H38V29.6667Z" data-v-bddf862b></path><path d="M72.6666 23H59.3333C57.86 23 56.6666 21.8067 56.6666 20.3333V7H70C71.4733 7 72.6666 8.19333 72.6666 9.66667V16.3333H66V11H63.3333V19H72.6666V23Z" data-v-bddf862b></path><path d="M35.3333 0.333344V23H21.9999C20.5266 23 19.3333 21.8067 19.3333 20.3333V9.66668C19.3333 8.19334 20.5266 7.00001 21.9999 7.00001H25.9999V19H28.6666V0.333344H35.3333Z" data-v-bddf862b></path>', 5)
      ]), 8, m)),
      t.label ? (o(), e("div", H, [
        a[1] || (a[1] = d("span", {
          "aria-hidden": !0,
          class: "ds-logo__divider"
        }, null, -1)),
        d("span", g, n(t.label), 1)
      ])) : r("", !0)
    ], 2));
  }
}), u = /* @__PURE__ */ p(c, [["__scopeId", "data-v-bddf862b"]]);
export {
  u as default
};
